import { authenticatedClient } from '../lib/client';
import { API_KEY_ENDPOINTS } from './api_keys.utils';
import type { ApiResponse } from '../lib/types';
import type { 
    CreateApiKeyResponse, 
    GetApiKeysApiResponse,
    CreateApiKeyRequest,
    ApiKey
} from './api_keys.types';

export const getApiKeys = async (): Promise<ApiResponse<ApiKey[]>> => {
    try {
        const response = await authenticatedClient.get(API_KEY_ENDPOINTS.GET_ALL);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to fetch API keys' };
    }
};

export const createApiKey = async (data: CreateApiKeyRequest): Promise<ApiResponse<CreateApiKeyResponse>> => {
    try {
        const response = await authenticatedClient.post(API_KEY_ENDPOINTS.CREATE, data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to create API key' };
    }
};

export const deleteApiKey = async (apiKeyId: string): Promise<ApiResponse> => {
    try {
        const response = await authenticatedClient.delete(API_KEY_ENDPOINTS.DELETE(apiKeyId));
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to delete API key' };
    }
};